import { ValuationApproachModel } from 'api';
import { getApproachesByType } from 'pages/ValuationsAllocation/util/getApproachesByType';

const getDefaultCompsApproachForDropdown = (approaches?: ValuationApproachModel[], approachTypes?: string[]) => {
  if (!approaches || !approachTypes) {
    return null;
  }
  const approachesByType = getApproachesByType({
    approaches,
    approachTypes,
  });

  if (approachesByType.length > 0) {
    return approachesByType[0];
  }

  return null;
};

export default getDefaultCompsApproachForDropdown;
